import { useEffect, useState } from "react";
import Hero from "@/components/home/Hero";
import TrustBar from "@/components/home/TrustBar";
import VendorBento from "@/components/home/VendorBento";
import AuxServices from "@/components/home/AuxServices";
import CtaSection from "@/components/home/CtaSection";
import Testimonials from "@/components/home/Testimonials";
import { fetchCourses } from "@/lib/api";

export default function HomePage() {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    fetchCourses().then(setCourses).catch(() => setCourses([]));
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <TrustBar />
      <VendorBento courses={courses} />
      <AuxServices />
      <Testimonials />
      <CtaSection />
    </div>
  );
}
